var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-box"},[_c('div',{staticClass:"data-wrapper"},[_c('BookingDayChart',{ref:"BookingDayChartRef"}),_c('BookingCountChart',{ref:"BookingCountChartRef"}),_c('BookingCountDeviceChart',{ref:"BookingCountDeviceChartRef"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }